module.exports = {"id":"dp2_2l3q2","text":"Sharing Through Digital Technologies","instructions":"Which responsibility applies when sharing information in digital environments?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.2","questionType":"PickOne","random":true,"options":[{"id":"dp2_2l3q2-a1","text":"Considering accuracy and potential impact","score":3.7},{"id":"dp2_2l3q2-a2","text":"Sharing content as quickly as possible","score":1.3},{"id":"dp2_2l3q2-a3","text":"Relying only on platform popularity","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l3q2.json
// module id = 1017
// module chunks = 41